import React, { KeyboardEvent, useEffect, useState } from 'react';
import { useOpenAnimations } from '../../hooks/common';
import ContentContainer from './ContentContainer';
import { InnoIcon } from '@innomotics/innomotics-build-react-lib';

export enum BannerType {
    Error,
    Info,
    Success,
    Warning
}

interface BannerProps {
    text: string;
    type: BannerType;
    dark?: boolean;
    onDisappear?: () => void;
}

const Banner = ({ dark, text, type, onDisappear }: BannerProps) => { //TODO: REPLACE WITH STH???
    const [visible, setVisible] = useState(false);
    const [animationClass, onAnimationEnd, contentRef, height] = useOpenAnimations<HTMLDivElement>(visible);

    useEffect(() => {
        setVisible(true);
    }, []);

    const handleAnimationEnd = () => {
        onAnimationEnd();

        if (onDisappear && !visible) {
            onDisappear();
        }
    };

    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setVisible(false);
        }
    };

    const getTypeClass = () => {
        switch (type) {
            case BannerType.Error:
                return 'error';
            case BannerType.Info:
                return 'info';
            case BannerType.Success:
                return 'success';
            case BannerType.Warning:
                return 'warning';
        }
    };

    const getIconType = () => {
        switch (type) {
            case BannerType.Error:
                return 'error';
            case BannerType.Info:
                return 'information';
            case BannerType.Success:
                return 'success';
            case BannerType.Warning:
                return 'warning';
        }
    };

    return (
        <div className={`banner ${getTypeClass()} ${animationClass} ${dark ? 'dark' : ''}`} style={{ height }} onAnimationEnd={handleAnimationEnd}>
            <div className='banner-content-container'>
                <ContentContainer>
                    <div ref={contentRef} className='banner-content'>
                        <InnoIcon size={32} icon={getIconType()} style={{ color: 'red' }} />
                        <div className='banner-text'>
                            {text}
                        </div>
                        {onDisappear &&
                            <div className='banner-close-button' tabIndex={0} onClick={() => setVisible(false)} onKeyDown={handleKeyDown}>
                                <InnoIcon size={32} icon='close' style={{ color: 'white' }} />
                            </div>
                        }
                    </div>
                </ContentContainer>
            </div>
        </div>
    );
};

export default Banner;
